import { instantMeiliSearch } from '@meilisearch/instant-meilisearch';

import { meilisearchConfigs } from '../../env';
import NavigationHits from './NavigationHits';
import NavigationSearch from './NavigationSearch';
import PageHits from './PageHits';
import Search from './Search';

const meilisearch = meilisearchConfigs();
const searchClient = instantMeiliSearch(meilisearch.url, meilisearch.masterKey);
const indexName = 'Goldencobra_Article';

export {
  searchClient,
  indexName,
  NavigationHits,
  NavigationSearch,
  PageHits,
  Search
};



// WEBPACK FOOTER //
// ./components/search/index.js